"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PlusIcon = exports.Option = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Add = _interopRequireDefault(require("@paprika/icon/lib/Add"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var blueSelected = _tokens["default"].color.blueLighten50;
var disabledStyles = (0, _styledComponents.css)(["background:transparent;border:0;color:", ";outline:none;&:focus{", " border-bottom-color:transparent;border-radius:", ";}"], _tokens["default"].color.blackLighten60, _stylers["default"].focusRing.subtle(), _tokens["default"].border.radius);

var stateStyles = function stateStyles(_ref) {
  var isSelected = _ref.isSelected,
      hasPreventDefaultOnSelect = _ref.hasPreventDefaultOnSelect;
  return (0, _styledComponents.css)(["&:hover{", ";background:", ";}&:focus{border-bottom-color:transparent;", "}"], hasPreventDefaultOnSelect ? "background: transparent;" : "", isSelected ? blueSelected : _tokens["default"].color.blackLighten70, hasPreventDefaultOnSelect ? _stylers["default"].focusRing.subtle(true) : _stylers["default"].focusRing(true));
};

var Option = _styledComponents["default"].li.withConfig({
  displayName: "Optionstyles__Option",
  componentId: "sc-nkqkwn-0"
})(function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      isSelected = _ref2.isSelected;
  return (0, _styledComponents.css)(["align-items:center;cursor:pointer;display:flex;max-height:", ";min-height:", ";padding-left:", ";", " &:hover{", ";}", " ", ""], _stylers["default"].spacer(6), _stylers["default"].spacer(4), _tokens["default"].spaceLg, _stylers["default"].fontSize(-1), isDisabled ? "cursor: not-allowed;" : "", isSelected ? "background: ".concat(blueSelected, ";") : "", isDisabled ? disabledStyles : stateStyles);
});

exports.Option = Option;
var PlusIcon = (0, _styledComponents["default"])(_Add["default"]).withConfig({
  displayName: "Optionstyles__PlusIcon",
  componentId: "sc-nkqkwn-1"
})(["color:", ";font-size:20px;padding-right:", ";"], _tokens["default"].color.blackLighten20, _tokens["default"].space);
exports.PlusIcon = PlusIcon;
//# sourceMappingURL=Option.styles.js.map